import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { useLocation, useSearchParams } from "react-router-dom";
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import featureDisplay from "../../../../common/utils/featureDisplay";
import InputPlusIcon from "../../../../common/components/input/InputPlusIcon";
import IconUser from "../../../../../images/icon_user_active/icon_user_active.svg";
import IconLocation from "../../../../../images/icon_location_active/icon_location_active.svg";
import IconEmail from "../../../../../images/icon_email_active/icon_email_active.svg";
import IconPassword from "../../../../../images/icon_password_active/icon_password_active.svg";
import ButtonMain from "../../../../common/components/button/ButtonMain";
import { validateEmail } from "../../../../common/utils/validator";
import fireAuth from "../../../../api/firebase/auth/utils";
import { setCommonDialogContext } from "../../../../reduxStore/commonSlice";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const StyledLinkDark = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#121212",
  cursor: "pointer",
}));

const StyledLinkBlue = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#3bbff0",
  cursor: "pointer",
}));

const StyledHint = styled(
  "span",
  {}
)(({ theme }) => ({
  color: "#ff5252",
}));

const EmailSignUp = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const backUrl = searchParams.get("backUrl");
  const location = useLocation();
  // store
  const reduxDispatch = useDispatch();
  const [state, dispath] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [inputMain, setInputMain] = useState({
    username: { value: "", hint: "" },
    company: { value: "", hint: "" },
    email: { value: "", hint: "" },
    password: { value: "", hint: "" },
    passwordConfirm: { value: "", hint: "" },
  });

  const emailValidate = validateEmail(inputMain.email.value);
  const usernameValidate = !!inputMain.username.value;
  const passwordTheSame =
    inputMain.password.value === inputMain.passwordConfirm.value;
  const passwordValidate = !!inputMain.password.value && passwordTheSame;
  const inputAllValidated =
    emailValidate && passwordValidate && usernameValidate;
  const disabledSubmit = !inputAllValidated;

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );

  const handleInputChange = (inputName) => (e) => {
    const inputVal = e.target.value;
    if (inputName in inputMain) {
      setInputMain((prev) => ({
        ...prev,
        [inputName]: {
          ...prev[inputName],
          value: inputVal,
        },
      }));
    }
  };

  const handleSubmit = () => {
    if (inputAllValidated) {
      const createSuccess = ({ user: loginUser }) => {
        const verifySuccess = () => {
          setLoading(false);
          const { displayName: userName } = loginUser;
          reduxDispatch(
            setCommonDialogContext({
              openSignal: Date.now(),
              title: intl.formatMessage(
                {
                  id: "signup.success.message",
                  defaultMessage: "{name}， 你已成功註冊",
                },
                {
                  name: userName,
                }
              ),
              contentText: [`請前往信箱中驗證`],
              // contentText: [`重新登入後即可使用本網站功能`],
              yesText: "好",
              withFinishIcon: true,
              onYes: () => {
                dispath({
                  type: Act.FIREBASE_LOGIN_USER,
                  payload: {
                    displayName: userName,
                  },
                });
                console.log("backUrl", backUrl);
                if (backUrl) {
                  // e.g. "/zh-tw/invitation?inviteid=XhJ8ExvHgjJj8prVw4ti"
                  navigate(backUrl);
                } else {
                  // redirect to sna page
                  navigate(handleLocaleRoute(ROUTE_PATH.LogIn));
                }
              },
            })
          );
        };
        const verifyError = ({ errorCode, errorMessage }) => {
          setLoading(false);
          reduxDispatch(
            setCommonDialogContext({
              openSignal: Date.now(),
              title: "寄送認證電子郵件失敗",
              contentText: [errorMessage],
              yesText: "好",
            })
          );
        };
        // 寄發驗證信
        fireAuth.sendEmailVerification({
          onSuccess: verifySuccess,
          onError: verifyError,
        });
      };
      const createError = ({ errorCode, errorMessage }) => {
        if (errorCode === "auth/email-already-in-use") {
          setInputMain((prev) => ({
            ...prev,
            email: {
              ...prev.email,
              hint: "已有人註冊此 email",
            },
          }));
        }
        if (errorCode === "auth/invalid-email") {
          setInputMain((prev) => ({
            ...prev,
            email: {
              ...prev.email,
              hint: "email 不符規定",
            },
          }));
        }
        if (errorCode === "auth/weak-password") {
          setInputMain((prev) => ({
            ...prev,
            password: {
              ...prev.password,
              hint: "密碼強度不足",
            },
          }));
        }
        setLoading(false);

        reduxDispatch(
          setCommonDialogContext({
            openSignal: Date.now(),
            title: intl.formatMessage({
              id: "signup.failure.message",
              defaultMessage: "註冊失敗，請重新註冊",
            }),
            // contentText: [],
            yesText: "好",
          })
        );
      };
      setLoading(true);
      fireAuth.createUser({
        email: inputMain.email.value,
        password: inputMain.password.value,
        displayName: inputMain.username.value,
        company: inputMain.company.value,
        onSuccess: createSuccess,
        onError: createError,
      });
    }
  };

  const handleDisplayPassword = (e) => {
    const checkedVal = e.target.checked;
    setShowPassword(checkedVal);
  };

  const inputSetting = [
    {
      inputName: "username",
      placeholder: intl.formatMessage({
        id: "signup.input.username.required",
        defaultMessage: "使用者名稱 *",
      }),
      inputType: "text",
      iconSrc: IconUser,
      iconAlt: "icon email",
      error: false,
      display: true,
    },
    {
      inputName: "company",
      placeholder: intl.formatMessage({
        id: "signup.input.company",
        defaultMessage: "服務單位",
      }),
      inputType: "text",
      iconSrc: IconLocation,
      iconAlt: "icon company",
      error: false,
      display: false, // todo:暫時不顯示,因為沒有儲存至 realtime database
    },
    {
      inputName: "email",
      placeholder: intl.formatMessage({
        id: "signup.input.email.required",
        defaultMessage: "電子郵件 *",
      }),
      inputType: "text",
      iconSrc: IconEmail,
      iconAlt: "icon email",
      error: inputMain?.email?.value && !emailValidate,
      display: true,
    },
    {
      inputName: "password",
      placeholder: intl.formatMessage({
        id: "signup.input.password.required",
        defaultMessage: "密碼 *",
      }),
      inputType: showPassword ? "text" : "password",
      iconSrc: IconPassword,
      iconAlt: "icon password",
      error: false,
      display: true,
    },
    {
      inputName: "passwordConfirm",
      placeholder: intl.formatMessage({
        id: "signup.input.passwordConfirm.required",
        defaultMessage: "確認密碼",
      }),
      inputType: showPassword ? "text" : "password",
      iconSrc: IconPassword,
      iconAlt: "icon password",
      error: false,
      display: true,
    },
  ];

  //
  return (
    <Box>
      {inputSetting
        .filter((o) => o.display)
        .map((item, idx) => (
          <Box mb={2} key={idx.toString()}>
            <InputPlusIcon
              // label="Email"
              type={item.inputType}
              placeholder={item.placeholder}
              startAdornmentIcon={<img src={item.iconSrc} alt={item.iconAlt} />}
              onChange={handleInputChange(item.inputName)}
              error={!!item.error}
            />
            {item?.inputName in inputMain && inputMain[item.inputName]?.hint && (
              <Box mt={1}>
                <Typography variant="body2">
                  <StyledHint>{inputMain[item.inputName].hint}</StyledHint>
                </Typography>
              </Box>
            )}
          </Box>
        ))}
      <Box
        mb={2}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
      >
        <Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showPassword}
                  onChange={handleDisplayPassword}
                />
              }
              label={intl.formatMessage({
                id: "signup.display.password",
                defaultMessage: "顯示密碼",
              })}
            />
          </FormGroup>
        </Box>
      </Box>
      <Box mb={8}>
        <ButtonMain
          buttonProps={{
            text: intl.formatMessage({
              id: "signup.submit",
              defaultMessage: "註冊",
            }),
            variant:
              (loading && "loading") || disabledSubmit
                ? "disabled"
                : "gradient",
            fullWidth: true,
            disabled: disabledSubmit,
            onClick: handleSubmit,
          }}
        />
      </Box>
    </Box>
  );
};

EmailSignUp.propTypes = {};

EmailSignUp.defaultProps = {};

export default EmailSignUp;
